import { render, staticRenderFns } from "./SaleManagement.vue?vue&type=template&id=6ddf6028"
import script from "./SaleManagement.vue?vue&type=script&lang=js"
export * from "./SaleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports